import { render, staticRenderFns } from "./DocumentManagement.vue?vue&type=template&id=29ec1fb5&scoped=true"
import script from "./DocumentManagement.vue?vue&type=script&lang=js"
export * from "./DocumentManagement.vue?vue&type=script&lang=js"
import style0 from "./DocumentManagement.vue?vue&type=style&index=0&id=29ec1fb5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ec1fb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ec1fb5')) {
      api.createRecord('29ec1fb5', component.options)
    } else {
      api.reload('29ec1fb5', component.options)
    }
    module.hot.accept("./DocumentManagement.vue?vue&type=template&id=29ec1fb5&scoped=true", function () {
      api.rerender('29ec1fb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/DocumentManagement.vue"
export default component.exports